"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncate = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var LoginModal_1 = __importDefault(require("../login/LoginModal"));
var truncate = function (text, _a) {
    if (text === void 0) { text = ""; }
    var _b = _a === void 0 ? [6, 6] : _a, h = _b[0], t = _b[1];
    var head = text.slice(0, h);
    var tail = text.slice(-1 * t, text.length);
    return text.length > h + t ? [head, tail].join("...") : text;
};
exports.truncate = truncate;
function HeaderLogin(_a) {
    var logout = _a.logout, address = _a.address, isAuthorized = _a.isAuthorized;
    var _b = (0, react_1.useState)(false), openLoginModal = _b[0], setOpenLoginModal = _b[1];
    var _c = (0, react_1.useState)(false), showSignUp = _c[0], setShowSignUp = _c[1];
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "headerButtons" }, { children: [(0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("button", __assign({ id: "loginBtnHead", className: "btn headerBtn headerBtn--connect headerBtn--outline px-3 mb-2 mb-lg-0", type: "button" }, { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: "https://app.loop.fans/?modal=login" }, { children: "Log In" })) })), (0, jsx_runtime_1.jsx)("button", __assign({ id: "loginBtnHead", className: "btn headerBtn headerBtn--connect px-3 mb-2 mb-lg-0", type: "button" }, { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: "https://app.loop.fans/?modal=signup" }, { children: "Join now" })) }))] }), (0, jsx_runtime_1.jsx)(LoginModal_1.default, { open: openLoginModal, close: function () { return setOpenLoginModal(false); }, showSignup: showSignUp, setShowSignUp: setShowSignUp })] })));
}
exports.default = HeaderLogin;
